<template>
  <div class="record-export-summary">
    <div class="breakdown-title">
      <h3 class="font-bold">Records Exported</h3
      ><h3 :class="`text-${color}-text`">{{ percentOfBase }}</h3>
    </div>
    <BittsProgressBar :width="limitUsedWidth" class="h-8 my-8" :color />
    <div class="breakdown-description">
      <span>Your plan renews {{ formattedDate }}</span>
      <div>
        <strong class="font-bold text-neutral-text-strong">
          {{ recordsExported?.toLocaleString() ?? 0 }}
        </strong>
        / {{ exportBaseLimit?.toLocaleString() ?? 0 }}
      </div>
    </div>
    <p
      v-if="hasExportExcess"
      data-testid="export-excess-note"
      class="record-export-summary__excess"
    >
      +{{ exportExcess.toLocaleString() }} authorized under your agreement
    </p>
  </div>
</template>

<script setup lang="ts">
import { BittsProgressBar } from '@crossbeam/bitts';

import { DateTime } from 'luxon';
import { computed } from 'vue';

import useRecordExportLimits from '@/composables/useRecordExportLimits';

const {
  recordsExported,
  exportBaseLimit,
  exportExcess,
  hasExportExcess,
  exportLimitStatus,
  percentOfBase,
  limitUsedWidth,
  endDate,
} = useRecordExportLimits();

const color = computed(() => {
  switch (exportLimitStatus.value) {
    case 'limit-reached':
      return 'danger';
    case 'over-90':
      return 'warning';
    default:
      return 'secondary';
  }
});

const formattedDate = computed(() =>
  endDate.value
    ? DateTime.fromISO(endDate.value).toLocaleString(DateTime.DATE_MED)
    : '',
);
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";
.breakdown-title {
  @apply flex justify-between;
}

.breakdown-description {
  @apply flex justify-between text-neutral-text-weak text-base mb-24;
}
.record-export-summary__excess {
  @apply text-sm text-neutral-text-weak -mt-16 mb-24;
}
</style>
